import axios from 'axios';
import { useEffect, useState } from 'react';
import { show_alerta } from '../../funciones.js';
import CONFIG from '../../config';

const URL = `${CONFIG.API_URL}/operarRoles.php`;

function Roles({ idUsuario, setUsuarios, rol, getUsuarios }) {
    const [roles, setRoles] = useState([]);
    const [niveles, setNiveles] = useState([]);
    const [rolSeleccionado, setRolSeleccionado] = useState(null); //control de seleccion
    const [nivelSeleccionado, setNivelSeleccionado] = useState('');

    const loggeduserRolId = localStorage.getItem('loggeduserRolId');

    useEffect(() => {
        setRolSeleccionado(null);
        setNivelSeleccionado('');
        axios.post(URL, { 'id_usuario': idUsuario, 'modo': 'buscarRoles', 'rol': loggeduserRolId })
            .then(res => {
                if (!res.data.error) {
                    setRoles(res.data);
                } else {
                    setRoles([]);
                }
            })
            .catch(err => {
                console.log(err);
            });

        axios.post(URL, { 'modo': 'listarNiveles' })
            .then(res => {
                if (Array.isArray(res.data)) {
                    setNiveles(res.data);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }, [idUsuario])


    const handleSubmint = (e) => {
        e.preventDefault();

        if (!rolSeleccionado) {
            show_alerta('Seleccione un rol', 'error');
            return;
        }

        const idRolNum = parseInt(rolSeleccionado);
        if ((idRolNum === 3 || idRolNum === 4 || idRolNum === 10) && !nivelSeleccionado) {
            show_alerta('Seleccione un nivel para el rol', 'error');
            return;
        }

        axios.post(URL, {
            'id_usuario': idUsuario,
            'modo': 'nuevoRol',
            'idRol': rolSeleccionado,
            'id_nivel': (idRolNum === 3 || idRolNum === 4 || idRolNum === 10) ? nivelSeleccionado : null
        })
            .then(res => {
                var tipo = res.data[0];
                var msj = res.data[1];
                show_alerta(msj, tipo);
                if (tipo === 'success') {
                    setRolSeleccionado(null);
                    setNivelSeleccionado('');
                    document.getElementById('btnCerrar2').click();
                    if (getUsuarios) getUsuarios();
                }
            })
            .catch(err => {
                show_alerta('Error en la acción ', 'error');
                console.log(err);
            })
    }

    return (
        <div>
            <form id='form' onSubmit={handleSubmint}>
                {roles.map((r) => (
                    //controlar que no pueda agregar un rol de numero inferior ni igual al que ya tiene asignado
                    (r.id > rol) && (r.id != 13) && (
                        <div key={r.id} className="form-check ms-2 mb-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                value={r.id}
                                name="flexRadioDefault"
                                id={`chek_${r.id}`}
                                checked={parseInt(rolSeleccionado) === r.id}
                                onChange={() => {
                                    setRolSeleccionado(r.id);
                                    setNivelSeleccionado('');
                                }}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`chek_${r.id}`}
                            >
                                <i className={r.icono}></i> {r.nombre}
                            </label>
                        </div>
                    )
                ))}

                {(parseInt(rolSeleccionado) === 3 || parseInt(rolSeleccionado) === 4 || parseInt(rolSeleccionado) === 10) && (
                    <div className="mt-3 mb-2 ms-2 me-2 p-2 border rounded bg-light">
                        <label className="form-label fw-bold small">Seleccionar Nivel Académico:</label>
                        <select
                            className="form-select form-select-sm"
                            value={nivelSeleccionado}
                            onChange={(e) => setNivelSeleccionado(e.target.value)}
                        >
                            <option value="">-- Seleccionar Nivel --</option>
                            {niveles.map((n) => (
                                <option key={n.id} value={n.id}>{n.denominacion}</option>
                            ))}
                        </select>
                    </div>
                )}

                <div className='row pe-3 pt-2'>
                    <button type='submit' className='btn btn-success m-2'>Agregar el rol seleccionado</button>
                </div>

            </form>
        </div>
    );
}

export default Roles;